import * as React from 'react';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { Table } from 'telstra-ui/components/table/Table';
import { Data } from '@telstra-connect/utils';
import './style.less'
import { navigateType } from '@utils/withRouterWrapper';

const MAX_DESCRIPTION_LENGTH = 100;

function formatIntDesc(description) {
    if (description) {
        description = description.replace(/(\r\n|\n|\r)/gm, ' ');
        return description.length > MAX_DESCRIPTION_LENGTH ? `${description.substr(0, MAX_DESCRIPTION_LENGTH)}...` : description;
    }
    return '';
}

const enquiryTableHeaderList = [
    'Enquiry number',
    'Enquiry status',
    'Category',
    'Enquiry details',
    'Assigned to',
    'Related order',
    'Enquiry submitted'
];

const renderCategory = {
    'Order enquiry': 'Order_Enquiry',
    'Billing enquiry': 'Billing_Enquiry'
}

const TABLE_ALIGN_LEFT = 'table-align-left';
const TD_ALIGN_LEFT = 'td-align-left';
const TD_ALIGN_LEFT_HEADING = 'td-align-left heading-color'
const sortProp = 'props'
const sortChild = 'children'
const columnsData = [
    {
        Header: (
            <div className="text-icon-wrapper">{enquiryTableHeaderList[0]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'caseId',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT_HEADING,
        minWidth: 55,
        sorting: true,
        resizable: false,

    },
    {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[1]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'status',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        resizable: false,
        sorting: true,
        minWidth: 55,
        sortMethod: (a, b) => {
            a = a[0][sortProp][sortChild];
            b = b[0][sortProp][sortChild];
            return b > a ? 1 : -1;
        },
    }, {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[2]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'enquiryCategory',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        resizable: false,
        sorting: true,
        minWidth: 65,
    }, {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[3]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'enquiryDetails',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        resizable: false,
        sorting: true,
        minWidth: 85,
        sortMethod: (a, b) => {
            a = a[0][sortProp][sortChild];
            b = b[0][sortProp][sortChild];
            return b > a ? 1 : -1;
        },
    },
    {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[4]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'assignedTo',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        resizable: false,
        sorting: true,
        minWidth: 45,
    },
    {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[5]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'relatedOrder',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        resizable: false,
        sorting: true,
        minWidth: 55,
    },
    {
        Header: (
            <div className="table-align-left">{enquiryTableHeaderList[6]}
                <SvgIcon name="icon-system-sorting-descending" className="tl-icon-arrow" />
            </div>
        ),
        accessor: 'dateRaised',
        headerClassName: TABLE_ALIGN_LEFT,
        className: TD_ALIGN_LEFT,
        sortMethod: (a, b) => {
            a = new Date(a).getTime();
            b = new Date(b).getTime();
            return b > a ? 1 : -1;
        },
        resizable: false,
        minWidth: 60,
    }
];

const renderTableInt = (cases, tabName, navigate: navigateType) => {
    const enquirySummaryList = [];
    /* istanbul ignore else */
    cases.map((enquiryItem, key) => {
        /* istanbul ignore else */
        const ID = key.toString();
        const caseId = enquiryItem.caseId;
        let statusInternal = enquiryItem.status;
        if (statusInternal === 'Assigned') {
            statusInternal = 'New';
        } else if (
            statusInternal === 'In Progress' ||
            statusInternal === 'Pending with Internal Team') {
            statusInternal = 'In Progress';
        } else if (
            statusInternal === 'Rejected') {
            statusInternal = 'Closed';
        }
        const status = statusInternal;
        const enquiryCategory = enquiryItem.enquiryCategory;
        const enquiryDetails = [(
            <div key={ID} title={enquiryItem.enquiryDetails}>
                {formatIntDesc(enquiryItem.enquiryDetails)}
            </div>
        )]
        const relatedOrder = enquiryItem.relatedOrder
        const enquirySubmitted = enquiryItem.enquirySubmitted

        let assignInternal = 'Telstra';
        if (status === 'On Hold') {
            assignInternal = 'Customer';
        } else if (status === 'Closed') {
            assignInternal = '-';
        }
        const assignedTo = assignInternal;
        const dateRaised = Data.DateUtil.formatDate(enquirySubmitted,
            Data.DateUtil.DateFormat.DEFAULT_DATE_UI);

        let statuswithicon = [(
            <div key={ID}>
                <SvgIcon name="icon-system-on-track"
                    className="icon-progress" />&nbsp;{status}
            </div>
        )];
        if (status === 'New') {
            statuswithicon = [(
                <div key={ID}>
                    <SvgIcon name="icon-system-circle-filled"
                        className="icon-new" />&nbsp;{status}
                </div>
            )];
        }

        if (status === 'On Hold') {
            statuswithicon = [(
                <div key={ID}>
                    <SvgIcon name="icon-system-on-hold"
                        className="icon-hold" />&nbsp;{status}
                </div>
            )];
        }

        if (status === 'Closed') {
            statuswithicon = [(
                <div key={ID}>
                    <SvgIcon name="icon-system-tick"
                        className="icon-closed" />&nbsp;{status}
                </div>
            )];
        }

        const enquirySummaryIntRow = {
            key: (ID),
            caseId,
            status: (statuswithicon),
            enquiryCategory,
            enquiryDetails,
            assignedTo,
            relatedOrder,
            dateRaised,
            rowCIDN: enquiryItem.accountId
        };
        enquirySummaryList.push(enquirySummaryIntRow);
    }
    )

    const onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: (e) => {
                const caseID = rowInfo.original.caseId;
                const selectedCidn = rowInfo.original.rowCIDN;
                const detailsURLOne = `/app/customer-support/enquiry/${caseID}/detail`;
                const detailsURL = `${detailsURLOne}?category=${renderCategory[tabName]}`
                const detailURLQuery = `${detailsURL}&selected_cidn=${selectedCidn}`
                navigate(detailURLQuery);
            }
        }
    }

    return (

        (
            <div className="intTable">
                <Table className="tc-enquiry-int-list-table"
                    data={enquirySummaryList}
                    columns={columnsData}
                    showPagination={true}
                    defaultPageSize={20}
                    defaultSortDesc={true}
                    getTrProps={onRowClick}
                />
            </div>
        )
    )
}

export { columnsData, renderTableInt };
